import { defineStore } from 'pinia'

export const useSiteSettingsStore = defineStore('siteSettings', {
  state: () => ({
    title: 'Binaffan',
    description: "Türkiye'nin en büyük çok satıcılı pazaryeri platformu",
    logo: null, // { id, path } from media picker or backend
    supportEmail: 'destek@Binaffan.com',
    supportPhone: '0850 888 88 88',
    socials: {
      instagram: 'https://instagram.com/Binaffan',
      facebook: 'https://www.facebook.com/Binaffan',
      whatsapp: 'https://wa.me/08508888888'
    }
  }),
  actions: {
    setAll(payload = {}) {
      this.title = payload.title ?? this.title
      this.description = payload.description ?? this.description
      this.logo = payload.logo ?? this.logo
      this.supportEmail = payload.supportEmail ?? this.supportEmail
      this.supportPhone = payload.supportPhone ?? this.supportPhone
      this.socials = {
        instagram: payload.socials?.instagram ?? this.socials.instagram,
        facebook: payload.socials?.facebook ?? this.socials.facebook,
        whatsapp: payload.socials?.whatsapp ?? this.socials.whatsapp
      }
    },
    setLogoFromMedia(images) {
      if (Array.isArray(images) && images[0]) {
        this.logo = images[0]
      } else if (images && images.path) {
        this.logo = images
      }
    }
  },
  getters: {
    logoUrl: (state) => state.logo?.path ? ('cl/' + state.logo.path) : '/logo.png'
  },

})
